var map = {
	"./apparel/apron/all-apron/GS-AP001/GS-AP001 (thumbnail).jpg": [
		10230,
		10230
	],
	"./apparel/apron/all-apron/GS-AP001/GS-AP001-1.jpg": [
		39977,
		39977
	],
	"./apparel/apron/all-apron/GS-AP001/GS-AP001.jpg": [
		41767,
		41767
	],
	"./apparel/apron/all-apron/GS-AP001/GS-AP001说明.xlsx": [
		99038,
		99038
	],
	"./apparel/apron/all-apron/GS-AP002/GS-AP002 (thumbnail).jpg": [
		27796,
		27796
	],
	"./apparel/apron/all-apron/GS-AP002/GS-AP002-1.jpg": [
		68375,
		68375
	],
	"./apparel/apron/all-apron/GS-AP002/GS-AP002-2.jpg": [
		17800,
		17800
	],
	"./apparel/apron/all-apron/GS-AP002/GS-AP002.jpg": [
		85237,
		85237
	],
	"./apparel/apron/all-apron/GS-AP002/GS-AP002说明.xlsx": [
		61192,
		61192
	],
	"./apparel/apron/all-apron/GS-AP002/GS-APxx-material-0.jpg": [
		29826,
		29826
	],
	"./apparel/apron/all-apron/GS-AP002/GS-APxx-material-1.jpg": [
		49823,
		49823
	],
	"./apparel/apron/all-apron/GS-AP002/GS-APxx-material-2.jpg": [
		34864,
		34864
	],
	"./apparel/apron/all-apron/GS-AP002/GS-APxx-material-3.jpg": [
		61965,
		61965
	],
	"./apparel/apron/all-apron/GS-AP002/GS-APxx-material-4.jpg": [
		68614,
		68614
	],
	"./apparel/apron/all-apron/GS-AP002/GS-APxx-material-5.jpg": [
		49667,
		49667
	],
	"./apparel/apron/all-apron/GS-AP003/GS-AP003 (thumbnail).jpg": [
		92258,
		92258
	],
	"./apparel/apron/all-apron/GS-AP003/GS-AP003-1.jpg": [
		88469,
		88469
	],
	"./apparel/apron/all-apron/GS-AP003/GS-AP003.jpg": [
		26139,
		26139
	],
	"./apparel/apron/all-apron/GS-AP003/GS-AP003说明.xlsx": [
		6798,
		6798
	],
	"./apparel/apron/all-apron/GS-AP003/GS-APxx-material-0.jpg": [
		13261,
		13261
	],
	"./apparel/apron/all-apron/GS-AP003/GS-APxx-material-1.jpg": [
		52016,
		52016
	],
	"./apparel/apron/all-apron/GS-AP003/GS-APxx-material-2.jpg": [
		35743,
		35743
	],
	"./apparel/apron/all-apron/GS-AP003/GS-APxx-material-3.jpg": [
		27682,
		27682
	],
	"./apparel/apron/all-apron/GS-AP003/GS-APxx-material-4.jpg": [
		12913,
		12913
	],
	"./apparel/apron/all-apron/GS-AP003/GS-APxx-material-5.jpg": [
		41108,
		41108
	],
	"./apparel/apron/all-apron/GS-AP004/GS-AP004 (thumbnail).jpg": [
		44260,
		44260
	],
	"./apparel/apron/all-apron/GS-AP004/GS-AP004.jpg": [
		20997,
		20997
	],
	"./apparel/apron/all-apron/GS-AP004/GS-AP004说明.xlsx": [
		92028,
		92028
	],
	"./apparel/apron/all-apron/GS-AP004/GS-APxx-material-0.jpg": [
		24648,
		24648
	],
	"./apparel/apron/all-apron/GS-AP004/GS-APxx-material-1.jpg": [
		52261,
		52261
	],
	"./apparel/apron/all-apron/GS-AP004/GS-APxx-material-2.jpg": [
		95034,
		95034
	],
	"./apparel/apron/all-apron/GS-AP004/GS-APxx-material-3.jpg": [
		46967,
		46967
	],
	"./apparel/apron/all-apron/GS-AP004/GS-APxx-material-4.jpg": [
		86732,
		86732
	],
	"./apparel/apron/all-apron/GS-AP004/GS-APxx-material-5.jpg": [
		873,
		873
	],
	"./apparel/apron/all-apron/thumbnail/GS-AP001 (thumbnail).jpg": [
		32015,
		32015
	],
	"./apparel/apron/cover/cover.png": [
		11136,
		11136
	],
	"./apparel/pajama/all-pajama/GS-P001/GS-P001 (thumbnail).jpg": [
		31852,
		31852
	],
	"./apparel/pajama/all-pajama/GS-P001/GS-P001-1.jpg": [
		47279,
		47279
	],
	"./apparel/pajama/all-pajama/GS-P001/GS-P001-2.jpg": [
		33664,
		33664
	],
	"./apparel/pajama/all-pajama/GS-P001/GS-P001-3.jpg": [
		72893,
		72893
	],
	"./apparel/pajama/all-pajama/GS-P001/GS-P001-4.jpg": [
		41430,
		41430
	],
	"./apparel/pajama/all-pajama/GS-P001/GS-P001.jpg": [
		19837,
		19837
	],
	"./apparel/pajama/all-pajama/GS-P001/GS-P001说明.xlsx": [
		35440,
		35440
	],
	"./apparel/pajama/all-pajama/GS-P002/GS-P002 (thumbnail).jpg": [
		19876,
		19876
	],
	"./apparel/pajama/all-pajama/GS-P002/GS-P002-2.jpg": [
		12312,
		12312
	],
	"./apparel/pajama/all-pajama/GS-P002/GS-P002-3.jpg": [
		20181,
		20181
	],
	"./apparel/pajama/all-pajama/GS-P002/GS-P002.jpg": [
		90437,
		90437
	],
	"./apparel/pajama/all-pajama/GS-P002/GS-P002说明.xlsx": [
		90272,
		90272
	],
	"./apparel/pajama/all-pajama/GS-P003/GS-P003 (thumbnail).jpg": [
		79588,
		79588
	],
	"./apparel/pajama/all-pajama/GS-P003/GS-P003-1.jpg": [
		76455,
		76455
	],
	"./apparel/pajama/all-pajama/GS-P003/GS-P003-2.jpg": [
		13880,
		13880
	],
	"./apparel/pajama/all-pajama/GS-P003/GS-P003-3.jpg": [
		4789,
		4789
	],
	"./apparel/pajama/all-pajama/GS-P003/GS-P003.jpg": [
		42789,
		42789
	],
	"./apparel/pajama/all-pajama/GS-P003/GS-P003说明.xlsx": [
		90080,
		90080
	],
	"./apparel/pajama/all-pajama/thumbnail/GS-P001 (thumbnail).jpg": [
		49254,
		49254
	],
	"./apparel/pajama/cover/cover.png": [
		2962,
		2962
	],
	"./linen/fabric/all-fabric/C40S140x100-1cmST/C40S140x100-1cmST (thumbnail).jpg": [
		75985,
		75985
	],
	"./linen/fabric/all-fabric/C40S140x100-1cmST/C40S140x100-1cmST.jpg": [
		48876,
		48876
	],
	"./linen/fabric/all-fabric/C40S140x100-1cmST/面料图解释.xls": [
		66446,
		66446
	],
	"./linen/fabric/all-fabric/C40S140x100-3cmST/C40S140x100-3cmST (thumbnail).jpg": [
		39261,
		39261
	],
	"./linen/fabric/all-fabric/C40S140x100-3cmST/C40S140x100-3cmST.jpg": [
		69088,
		69088
	],
	"./linen/fabric/all-fabric/C40S140x100-3cmST/面料图解释.xls": [
		83800,
		83800
	],
	"./linen/fabric/all-fabric/C40S140x100-5mmST/C40S140x100-5mmST (thumbnail).jpg": [
		51669,
		51669
	],
	"./linen/fabric/all-fabric/C40S140x100-5mmST/C40S140x100-5mmST.jpg": [
		72680,
		72680
	],
	"./linen/fabric/all-fabric/C40S140x100-5mmST/面料图解释.xls": [
		79184,
		79184
	],
	"./linen/fabric/all-fabric/C40S140x100-65mm-Checker/C40S140x100-65mm-Checker (thumbnail).jpg": [
		34027,
		34027
	],
	"./linen/fabric/all-fabric/C40S140x100-65mm-Checker/C40S140x100-65mm-Checker.jpg": [
		48982,
		48982
	],
	"./linen/fabric/all-fabric/C40S140x100-65mm-Checker/面料图解释.xls": [
		1189,
		1189
	],
	"./linen/fabric/all-fabric/C40S140x100-Satin weave/C40S140x100-Satin weave (thumbnail).jpg": [
		29925,
		29925
	],
	"./linen/fabric/all-fabric/C40S140x100-Satin weave/C40S140x100-Satin weave.jpg": [
		26008,
		26008
	],
	"./linen/fabric/all-fabric/C40S140x100-Satin weave/面料图解释.xls": [
		6325,
		6325
	],
	"./linen/fabric/all-fabric/C40S140x110-2cmST/C40S140x110-2cmST (thumbnail).jpg": [
		77921,
		77921
	],
	"./linen/fabric/all-fabric/C40S140x110-2cmST/C40S140x110-2cmST.jpg": [
		30940,
		30940
	],
	"./linen/fabric/all-fabric/C40S140x110-2cmST/面料图解释.xls": [
		98490,
		98490
	],
	"./linen/fabric/all-fabric/C40S140x110-3cmST/C40S140x110-3cmST (thumbnail).jpg": [
		11193,
		11193
	],
	"./linen/fabric/all-fabric/C40S140x110-3cmST/C40S140x110-3cmST.jpg": [
		51204,
		51204
	],
	"./linen/fabric/all-fabric/C40S140x110-3cmST/面料图解释.xls": [
		9099,
		9099
	],
	"./linen/fabric/all-fabric/C40S140x110-Satin weave/C40S140x110-Satin weave (thumbnail).jpg": [
		45521,
		45521
	],
	"./linen/fabric/all-fabric/C40S140x110-Satin weave/C40S140x110-Satin weave.jpg": [
		97772,
		97772
	],
	"./linen/fabric/all-fabric/C40S140x110-Satin weave/面料图解释.xls": [
		25306,
		25306
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80 15mm-Checker/TC3070-34S130x80 15mm-Checker (thumbnail).jpg": [
		26329,
		26329
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80 15mm-Checker/TC3070-34S130x80 15mm-Checker.jpg": [
		80196,
		80196
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80 15mm-Checker/面料图解释.xls": [
		45529,
		45529
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80 25mm-Checker/TC3070-34S130x80 25mm-Checker (thumbnail).jpg": [
		43517,
		43517
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80 25mm-Checker/TC3070-34S130x80 25mm-Checker.jpg": [
		36896,
		36896
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80 25mm-Checker/面料图解释.xls": [
		8428,
		8428
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80-1.5cmST/TC3070-34S130x80-1.5cmST (thumbnail).jpg": [
		28099,
		28099
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80-1.5cmST/TC3070-34S130x80-1.5cmST.jpg": [
		98782,
		98782
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80-1.5cmST/面料图解释.xls": [
		39033,
		39033
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80-1cm ST/TC3070-34S 130x80-1cm ST (thumbnail).jpg": [
		56129,
		56129
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80-1cm ST/TC3070-34S 130x80-1cm ST.jpg": [
		39324,
		39324
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80-1cm ST/面料图解释.xls": [
		69636,
		69636
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80-2.5cmST/TC3070-34S130x80-2.5cmST (thumbnail).jpg": [
		67421,
		67421
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80-2.5cmST/TC3070-34S130x80-2.5cmST.jpg": [
		39296,
		39296
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80-2.5cmST/面料图解释.xls": [
		44970,
		44970
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80-Square pattern/TC3070-34S130x80-Square pattern (thumbnail).jpg": [
		52961,
		52961
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80-Square pattern/TC3070-34S130x80-Square pattern.jpg": [
		28540,
		28540
	],
	"./linen/fabric/all-fabric/TC3070-34S130x80-Square pattern/面料图解释.xls": [
		44129,
		44129
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100 2.5cmST/TC3070-40S140x100 2.5cmST (thumbnail).jpg": [
		13393,
		13393
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100 2.5cmST/TC3070-40S140x100 2.5cmST.jpg": [
		64204,
		64204
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100 2.5cmST/面料图解释.xls": [
		39854,
		39854
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100 3cmST/TC3070-40S140x100 3cmST (thumbnail).jpg": [
		47445,
		47445
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100 3cmST/TC3070-40S140x100 3cmST.jpg": [
		25064,
		25064
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100 3cmST/面料图解释.xls": [
		26828,
		26828
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100 60mm-Checker/TC3070-40S140x100 60mm-Checker (thumbnail).jpg": [
		3865,
		3865
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100 60mm-Checker/TC3070-40S140x100 60mm-Checker.jpg": [
		4836,
		4836
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100 60mm-Checker/面料图解释.xls": [
		46496,
		46496
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100 90mm-Checker/TC3070-40S140x100 90mm-Checker (thumbnail).jpg": [
		46955,
		46955
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100 90mm-Checker/TC3070-40S140x100 90mm-Checker.jpg": [
		29878,
		29878
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100 90mm-Checker/面料图解释.xls": [
		18401,
		18401
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100-1cm ST/TC3070-40S140x100-1cm ST (thumbnail).jpg": [
		91875,
		91875
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100-1cm ST/TC3070-40S140x100-1cm ST.jpg": [
		1598,
		1598
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100-1cm ST/面料图解释.xls": [
		14261,
		14261
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100-Line pattern/TC3070-40S140x100-Line pattern (thumbnail).jpg": [
		74683,
		74683
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100-Line pattern/TC3070-40S140x100-Line pattern.jpg": [
		88422,
		88422
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100-Line pattern/面料图解释.xls": [
		80791,
		80791
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100-Polka dot pattern/TC3070-40S140x100-Polka dot pattern (thumbnail).jpg": [
		59021,
		59021
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100-Polka dot pattern/TC3070-40S140x100-Polka dot pattern.jpg": [
		37872,
		37872
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100-Polka dot pattern/面料图解释.xls": [
		7379,
		7379
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100-Satin weave/TC3070-40S140x100-Satin weave (thumbnail).jpg": [
		85353,
		85353
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100-Satin weave/TC3070-40S140x100-Satin weave.jpg": [
		63604,
		63604
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100-Satin weave/面料图解释.xls": [
		86434,
		86434
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100-Square pattern/TC3070-40S140x100-Square pattern (thumbnail).jpg": [
		78457,
		78457
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100-Square pattern/TC3070-40S140x100-Square pattern.jpg": [
		54724,
		54724
	],
	"./linen/fabric/all-fabric/TC3070-40S140x100-Square pattern/面料图解释.xls": [
		2832,
		2832
	],
	"./linen/fabric/all-fabric/TC3070-40S173x80-Wave pattern/TC3070-40S173x80-Wave pattern (thumbnail).jpg": [
		13693,
		13693
	],
	"./linen/fabric/all-fabric/TC3070-40S173x80-Wave pattern/TC3070-40S173x80-Wave pattern.jpg": [
		49280,
		49280
	],
	"./linen/fabric/all-fabric/TC3070-40S173x80-Wave pattern/面料图解释.xls": [
		65381,
		65381
	],
	"./linen/fabric/all-fabric/TC5050-40S140x100 2.5mm-Checker/TC5050-40S140x100 2.5mm-Checker (thumbnail).jpg": [
		91937,
		91937
	],
	"./linen/fabric/all-fabric/TC5050-40S140x100 2.5mm-Checker/TC5050-40S140x100 2.5mm-Checker.jpg": [
		14300,
		14300
	],
	"./linen/fabric/all-fabric/TC5050-40S140x100 2.5mm-Checker/面料图解释.xls": [
		98143,
		98143
	],
	"./linen/fabric/all-fabric/TC5050-40S140x100 2cmST/TC5050-40S140x100 2cmST (thumbnail).jpg": [
		82557,
		82557
	],
	"./linen/fabric/all-fabric/TC5050-40S140x100 2cmST/TC5050-40S140x100 2cmST.jpg": [
		79776,
		79776
	],
	"./linen/fabric/all-fabric/TC5050-40S140x100 2cmST/面料图解释.xls": [
		29801,
		29801
	],
	"./linen/fabric/all-fabric/TC5050-40S140x100 3cmST/TC5050-40S140x100 3cmST (thumbnail).jpg": [
		59213,
		59213
	],
	"./linen/fabric/all-fabric/TC5050-40S140x100 3cmST/TC5050-40S140x100 3cmST.jpg": [
		81104,
		81104
	],
	"./linen/fabric/all-fabric/TC5050-40S140x100 3cmST/面料图解释.xls": [
		6200,
		6200
	],
	"./linen/fabric/all-fabric/TC5050-40S140x100 5mm-Checker/TC5050-40S140x100 5mm-Checker (thumbnail).jpg": [
		53541,
		53541
	],
	"./linen/fabric/all-fabric/TC5050-40S140x100 5mm-Checker/TC5050-40S140x100 5mm-Checker.jpg": [
		42008,
		42008
	],
	"./linen/fabric/all-fabric/TC5050-40S140x100 5mm-Checker/面料图解释.xls": [
		60991,
		60991
	],
	"./linen/fabric/all-fabric/TC5050-40S140x100-1cmST/TC5050-40S140x100-1cmST (thumbnail).jpg": [
		89613,
		89613
	],
	"./linen/fabric/all-fabric/TC5050-40S140x100-1cmST/TC5050-40S140x100-1cmST.jpg": [
		76944,
		76944
	],
	"./linen/fabric/all-fabric/TC5050-40S140x100-1cmST/面料图解释.xls": [
		82833,
		82833
	],
	"./linen/fabric/all-fabric/thumbnail/C40S140x100-1cmST (thumbnail).jpg": [
		41084,
		41084
	],
	"./linen/fabric/cover/cover.png": [
		40940,
		18559
	],
	"./linen/hospital/cover/cover.png": [
		96749,
		96749
	],
	"./linen/hospital/nurse-dress/GS-NU001/GS-NU001 (thumbnail).jpg": [
		8104,
		8104
	],
	"./linen/hospital/nurse-dress/GS-NU001/GS-NU001-1.jpg": [
		86475,
		86475
	],
	"./linen/hospital/nurse-dress/GS-NU001/GS-NU001-2.jpg": [
		2428,
		2428
	],
	"./linen/hospital/nurse-dress/GS-NU001/GS-NU001-3.jpg": [
		16153,
		16153
	],
	"./linen/hospital/nurse-dress/GS-NU001/GS-NU001.jpg": [
		61473,
		61473
	],
	"./linen/hospital/nurse-dress/GS-NU001/GS-NU001说明.xlsx": [
		61046,
		61046
	],
	"./linen/hospital/nurse-dress/thumbnail/GS-NU001 (thumbnail).jpg": [
		42309,
		42309
	],
	"./linen/hospital/others/GS-NV001/GS-NV001 (thumbnail).jpg": [
		81408,
		81408
	],
	"./linen/hospital/others/GS-NV001/GS-NV001.jpg": [
		15049,
		15049
	],
	"./linen/hospital/others/thumbnail/GS-NV001 (thumbnail).jpg": [
		36222,
		36222
	],
	"./linen/hospital/patient-clothes/GS-HW001/GS-HW001 (thumbnail).jpg": [
		1637,
		1637
	],
	"./linen/hospital/patient-clothes/GS-HW001/GS-HW001-1.jpg": [
		870,
		870
	],
	"./linen/hospital/patient-clothes/GS-HW001/GS-HW001.jpg": [
		29112,
		29112
	],
	"./linen/hospital/patient-clothes/GS-HW001/GS-HW001说明.xlsx": [
		98113,
		98113
	],
	"./linen/hospital/patient-clothes/GS-HW002/GS-HW002 (thumbnail).jpg": [
		10507,
		10507
	],
	"./linen/hospital/patient-clothes/GS-HW002/GS-HW002-1.jpg": [
		48420,
		48420
	],
	"./linen/hospital/patient-clothes/GS-HW002/GS-HW002-2.jpg": [
		48467,
		48467
	],
	"./linen/hospital/patient-clothes/GS-HW002/GS-HW002-3.jpg": [
		76854,
		76854
	],
	"./linen/hospital/patient-clothes/GS-HW002/GS-HW002-4.jpg": [
		33725,
		33725
	],
	"./linen/hospital/patient-clothes/GS-HW002/GS-HW002-5.jpg": [
		8160,
		8160
	],
	"./linen/hospital/patient-clothes/GS-HW002/GS-HW002.jpg": [
		39862,
		39862
	],
	"./linen/hospital/patient-clothes/GS-HW002/GS-HW002说明.xlsx": [
		54411,
		54411
	],
	"./linen/hospital/patient-clothes/GS-HW003/GS-HW003 (thumbnail).jpg": [
		20321,
		20321
	],
	"./linen/hospital/patient-clothes/GS-HW003/GS-HW003-1.jpg": [
		41218,
		41218
	],
	"./linen/hospital/patient-clothes/GS-HW003/GS-HW003-2.jpg": [
		87149,
		87149
	],
	"./linen/hospital/patient-clothes/GS-HW003/GS-HW003-3.jpg": [
		34928,
		34928
	],
	"./linen/hospital/patient-clothes/GS-HW003/GS-HW003.jpg": [
		40860,
		40860
	],
	"./linen/hospital/patient-clothes/GS-HW003/GS-HW003说明.xlsx": [
		13001,
		13001
	],
	"./linen/hospital/patient-clothes/GS-HW004/GS-HW004 (thumbnail).jpg": [
		76771,
		76771
	],
	"./linen/hospital/patient-clothes/GS-HW004/GS-HW004-1.jpg": [
		94556,
		94556
	],
	"./linen/hospital/patient-clothes/GS-HW004/GS-HW004-2.jpg": [
		62251,
		62251
	],
	"./linen/hospital/patient-clothes/GS-HW004/GS-HW004.jpg": [
		80702,
		80702
	],
	"./linen/hospital/patient-clothes/GS-HW004/GS-HW004说明.xlsx": [
		50519,
		50519
	],
	"./linen/hospital/patient-clothes/GS-HW005/GS-HW005 (thumbnail).jpg": [
		21757,
		21757
	],
	"./linen/hospital/patient-clothes/GS-HW005/GS-HW005-1.jpg": [
		38142,
		38142
	],
	"./linen/hospital/patient-clothes/GS-HW005/GS-HW005-2.jpg": [
		34089,
		34089
	],
	"./linen/hospital/patient-clothes/GS-HW005/GS-HW005-3.jpg": [
		62476,
		62476
	],
	"./linen/hospital/patient-clothes/GS-HW005/GS-HW005.jpg": [
		93824,
		93824
	],
	"./linen/hospital/patient-clothes/GS-HW005/GS-HW005说明.xlsx": [
		29169,
		29169
	],
	"./linen/hospital/patient-clothes/GS-HW006/GS-HW006 (thumbnail).jpg": [
		54555,
		54555
	],
	"./linen/hospital/patient-clothes/GS-HW006/GS-HW006-1.jpg": [
		70452,
		70452
	],
	"./linen/hospital/patient-clothes/GS-HW006/GS-HW006-2.jpg": [
		16515,
		16515
	],
	"./linen/hospital/patient-clothes/GS-HW006/GS-HW006-3.jpg": [
		26406,
		26406
	],
	"./linen/hospital/patient-clothes/GS-HW006/GS-HW006.jpg": [
		37414,
		37414
	],
	"./linen/hospital/patient-clothes/GS-HW006/GS-HW006说明.xlsx": [
		40779,
		40779
	],
	"./linen/hospital/patient-clothes/GS-HW007/GS-HW007 (thumbnail).jpg": [
		36737,
		36737
	],
	"./linen/hospital/patient-clothes/GS-HW007/GS-HW007-1.jpg": [
		40194,
		40194
	],
	"./linen/hospital/patient-clothes/GS-HW007/GS-HW007-2.jpg": [
		88685,
		88685
	],
	"./linen/hospital/patient-clothes/GS-HW007/GS-HW007-3.jpg": [
		45232,
		45232
	],
	"./linen/hospital/patient-clothes/GS-HW007/GS-HW007.jpg": [
		29052,
		29052
	],
	"./linen/hospital/patient-clothes/GS-HW007/GS-HW007说明.xlsx": [
		65049,
		65049
	],
	"./linen/hospital/patient-clothes/GS-HW008/GS-HW008 (thumbnail).jpg": [
		31459,
		31459
	],
	"./linen/hospital/patient-clothes/GS-HW008/GS-HW008-1.jpg": [
		26268,
		26268
	],
	"./linen/hospital/patient-clothes/GS-HW008/GS-HW008-2.jpg": [
		51435,
		51435
	],
	"./linen/hospital/patient-clothes/GS-HW008/GS-HW008-3.jpg": [
		55598,
		55598
	],
	"./linen/hospital/patient-clothes/GS-HW008/GS-HW008-4.jpg": [
		9013,
		9013
	],
	"./linen/hospital/patient-clothes/GS-HW008/GS-HW008-5.jpg": [
		47832,
		47832
	],
	"./linen/hospital/patient-clothes/GS-HW008/GS-HW008.jpg": [
		50270,
		50270
	],
	"./linen/hospital/patient-clothes/GS-HW008/GS-HW008说明.xlsx": [
		63903,
		63903
	],
	"./linen/hospital/patient-clothes/GS-HW009/GS-HW009 (thumbnail).jpg": [
		77301,
		77301
	],
	"./linen/hospital/patient-clothes/GS-HW009/GS-HW009-1.jpg": [
		56438,
		56438
	],
	"./linen/hospital/patient-clothes/GS-HW009/GS-HW009-2.jpg": [
		46017,
		46017
	],
	"./linen/hospital/patient-clothes/GS-HW009/GS-HW009-pattern-1.jpg": [
		69871,
		69871
	],
	"./linen/hospital/patient-clothes/GS-HW009/GS-HW009-pattern-10.jpg": [
		75039,
		75039
	],
	"./linen/hospital/patient-clothes/GS-HW009/GS-HW009-pattern-2.jpg": [
		56256,
		56256
	],
	"./linen/hospital/patient-clothes/GS-HW009/GS-HW009-pattern-3.jpg": [
		11837,
		11837
	],
	"./linen/hospital/patient-clothes/GS-HW009/GS-HW009-pattern-4.jpg": [
		64022,
		64022
	],
	"./linen/hospital/patient-clothes/GS-HW009/GS-HW009-pattern-5.jpg": [
		27187,
		27187
	],
	"./linen/hospital/patient-clothes/GS-HW009/GS-HW009-pattern-6.jpg": [
		91908,
		91908
	],
	"./linen/hospital/patient-clothes/GS-HW009/GS-HW009-pattern-7.jpg": [
		69953,
		69953
	],
	"./linen/hospital/patient-clothes/GS-HW009/GS-HW009-pattern-8.jpg": [
		78810,
		78810
	],
	"./linen/hospital/patient-clothes/GS-HW009/GS-HW009-pattern-9.jpg": [
		73271,
		73271
	],
	"./linen/hospital/patient-clothes/GS-HW009/GS-HW009.jpg": [
		53704,
		53704
	],
	"./linen/hospital/patient-clothes/GS-HW009/GS-HW009说明.xlsx": [
		54545,
		54545
	],
	"./linen/hospital/patient-clothes/GS-HW010/GS-HW010 (thumbnail).jpg": [
		69061,
		69061
	],
	"./linen/hospital/patient-clothes/GS-HW010/GS-HW010-1.jpg": [
		56326,
		56326
	],
	"./linen/hospital/patient-clothes/GS-HW010/GS-HW010-2.jpg": [
		14097,
		14097
	],
	"./linen/hospital/patient-clothes/GS-HW010/GS-HW010-3.jpg": [
		35572,
		35572
	],
	"./linen/hospital/patient-clothes/GS-HW010/GS-HW010-pattern-1.jpg": [
		24223,
		24223
	],
	"./linen/hospital/patient-clothes/GS-HW010/GS-HW010-pattern-10.jpg": [
		42703,
		42703
	],
	"./linen/hospital/patient-clothes/GS-HW010/GS-HW010-pattern-2.jpg": [
		39888,
		39888
	],
	"./linen/hospital/patient-clothes/GS-HW010/GS-HW010-pattern-3.jpg": [
		40813,
		40813
	],
	"./linen/hospital/patient-clothes/GS-HW010/GS-HW010-pattern-4.jpg": [
		43014,
		43014
	],
	"./linen/hospital/patient-clothes/GS-HW010/GS-HW010-pattern-5.jpg": [
		81539,
		81539
	],
	"./linen/hospital/patient-clothes/GS-HW010/GS-HW010-pattern-6.jpg": [
		87060,
		87060
	],
	"./linen/hospital/patient-clothes/GS-HW010/GS-HW010-pattern-7.jpg": [
		785,
		785
	],
	"./linen/hospital/patient-clothes/GS-HW010/GS-HW010-pattern-8.jpg": [
		38730,
		38730
	],
	"./linen/hospital/patient-clothes/GS-HW010/GS-HW010-pattern-9.jpg": [
		50887,
		50887
	],
	"./linen/hospital/patient-clothes/GS-HW010/GS-HW010.jpg": [
		50776,
		50776
	],
	"./linen/hospital/patient-clothes/GS-HW010/GS-HW010说明.xlsx": [
		73865,
		73865
	],
	"./linen/hospital/patient-clothes/thumbnail/GS-HW001 (thumbnail).jpg": [
		22694,
		22694
	],
	"./linen/hospital/scrubs/GS-SG001/GS-SG001 (thumbnail).jpg": [
		28069,
		28069
	],
	"./linen/hospital/scrubs/GS-SG001/GS-SG001-1.jpg": [
		53798,
		53798
	],
	"./linen/hospital/scrubs/GS-SG001/GS-SG001-2.jpg": [
		97905,
		97905
	],
	"./linen/hospital/scrubs/GS-SG001/GS-SG001-3.jpg": [
		67220,
		67220
	],
	"./linen/hospital/scrubs/GS-SG001/GS-SG001-4.jpg": [
		35007,
		35007
	],
	"./linen/hospital/scrubs/GS-SG001/GS-SG001.jpg": [
		9816,
		9816
	],
	"./linen/hospital/scrubs/GS-SG001/GS-SG001说明.xlsx": [
		2983,
		2983
	],
	"./linen/hospital/scrubs/thumbnail/GS-SG001 (thumbnail).jpg": [
		2359,
		2359
	],
	"./linen/hospital/thumbNail/thumbNail.png": [
		5969,
		5969
	],
	"./linen/hospital/thumbNail/thumbNail2.png": [
		45687,
		45687
	],
	"./linen/hospital/undergarments/GS-M001/GS-M001 (thumbnail).jpg": [
		94778,
		94778
	],
	"./linen/hospital/undergarments/GS-M001/GS-M001-1.jpg": [
		16493,
		16493
	],
	"./linen/hospital/undergarments/GS-M001/GS-M001-2.jpg": [
		70562,
		70562
	],
	"./linen/hospital/undergarments/GS-M001/GS-M001.jpg": [
		32131,
		32131
	],
	"./linen/hospital/undergarments/GS-M001/GS-M001.xlsx": [
		91958,
		91958
	],
	"./linen/hospital/undergarments/thumbnail/GS-M001 (thumbnail).jpg": [
		79819,
		79819
	],
	"./linen/hospital/waterproof-sheets/GS-WPS001/GS-WPS001 (thumbnail).jpg": [
		44211,
		44211
	],
	"./linen/hospital/waterproof-sheets/GS-WPS001/GS-WPS001-1.jpg": [
		63020,
		63020
	],
	"./linen/hospital/waterproof-sheets/GS-WPS001/GS-WPS001.jpg": [
		31598,
		31598
	],
	"./linen/hospital/waterproof-sheets/GS-WPS001/GS-WPS001说明.xlsx": [
		54615,
		54615
	],
	"./linen/hospital/waterproof-sheets/GS-WPS002/GS-WPS002 (thumbnail).jpg": [
		18323,
		18323
	],
	"./linen/hospital/waterproof-sheets/GS-WPS002/GS-WPS002-1.jpg": [
		18559,
		40940
	],
	"./linen/hospital/waterproof-sheets/GS-WPS002/GS-WPS002.jpg": [
		6606,
		6606
	],
	"./linen/hospital/waterproof-sheets/GS-WPS002/GS-WPS002说明.xlsx": [
		78791,
		78791
	],
	"./linen/hospital/waterproof-sheets/GS-WPS003/GS-WPS003 (thumbnail).jpg": [
		51275,
		51275
	],
	"./linen/hospital/waterproof-sheets/GS-WPS003/GS-WPS003-1.jpg": [
		79300,
		79300
	],
	"./linen/hospital/waterproof-sheets/GS-WPS003/GS-WPS003.jpg": [
		97526,
		97526
	],
	"./linen/hospital/waterproof-sheets/GS-WPS003/GS-WPS003说明.xlsx": [
		29087,
		29087
	],
	"./linen/hospital/waterproof-sheets/GS-WPS004/GS-WPS004 (thumbnail).jpg": [
		99459,
		99459
	],
	"./linen/hospital/waterproof-sheets/GS-WPS004/GS-WPS004-1.jpg": [
		58428,
		58428
	],
	"./linen/hospital/waterproof-sheets/GS-WPS004/GS-WPS004.jpg": [
		18558,
		18558
	],
	"./linen/hospital/waterproof-sheets/GS-WPS004/GS-WPS004说明.xlsx": [
		9623,
		9623
	],
	"./linen/hospital/waterproof-sheets/GS-WPS005/GS-WPS005 (thumbnail).jpg": [
		55035,
		55035
	],
	"./linen/hospital/waterproof-sheets/GS-WPS005/GS-WPS005-1.jpg": [
		35284,
		35284
	],
	"./linen/hospital/waterproof-sheets/GS-WPS005/GS-WPS005.jpg": [
		19782,
		19782
	],
	"./linen/hospital/waterproof-sheets/GS-WPS005/GS-WPS005说明.xlsx": [
		51279,
		51279
	],
	"./linen/hospital/waterproof-sheets/thumbnail/GS-WPS001 (thumbnail).jpg": [
		19349,
		19349
	],
	"./linen/hotel/bathrobe/GS-BR001/GS-BR001 (thumbnail).jpg": [
		25400,
		25400
	],
	"./linen/hotel/bathrobe/GS-BR001/GS-BR001-1.jpg": [
		4859,
		4859
	],
	"./linen/hotel/bathrobe/GS-BR001/GS-BR001-2.jpg": [
		62060,
		62060
	],
	"./linen/hotel/bathrobe/GS-BR001/GS-BR001.jpg": [
		72753,
		72753
	],
	"./linen/hotel/bathrobe/GS-BR001/GS-BR001说明.xlsx": [
		47514,
		47514
	],
	"./linen/hotel/bathrobe/GS-BR002/GS-BR002 (thumbnail).jpg": [
		96666,
		96666
	],
	"./linen/hotel/bathrobe/GS-BR002/GS-BR002-1.jpg": [
		30061,
		30061
	],
	"./linen/hotel/bathrobe/GS-BR002/GS-BR002-2.jpg": [
		81570,
		81570
	],
	"./linen/hotel/bathrobe/GS-BR002/GS-BR002.jpg": [
		7971,
		7971
	],
	"./linen/hotel/bathrobe/GS-BR002/GS-BR002说明.xlsx": [
		13400,
		13400
	],
	"./linen/hotel/bathrobe/thumbnail/GS-BR001 (thumbnail).jpg": [
		90230,
		90230
	],
	"./linen/hotel/bed-linen/GS-BD001/GS-BD001 (thumbnail).jpg": [
		84985,
		84985
	],
	"./linen/hotel/bed-linen/GS-BD001/GS-BD001-1.jpg": [
		88890,
		88890
	],
	"./linen/hotel/bed-linen/GS-BD001/GS-BD001.jpg": [
		740,
		740
	],
	"./linen/hotel/bed-linen/GS-BD001/GS-BD001说明.xlsx": [
		41787,
		41787
	],
	"./linen/hotel/bed-linen/thumbnail/GS-BD001 (thumbnail).jpg": [
		43003,
		43003
	],
	"./linen/hotel/cover/cover.png": [
		90273,
		90273
	],
	"./linen/hotel/gown/GS-G001/GS-G001 (thumbnail).jpg": [
		98410,
		98410
	],
	"./linen/hotel/gown/GS-G001/GS-G001-1.jpg": [
		7741,
		7741
	],
	"./linen/hotel/gown/GS-G001/GS-G001-2.jpg": [
		97842,
		97842
	],
	"./linen/hotel/gown/GS-G001/GS-G001-3.jpg": [
		65775,
		65775
	],
	"./linen/hotel/gown/GS-G001/GS-G001.jpg": [
		66899,
		66899
	],
	"./linen/hotel/gown/GS-G001/GS-G001说明.xlsx": [
		46276,
		46276
	],
	"./linen/hotel/gown/GS-G002/GS-G001说明.xlsx": [
		71469,
		71469
	],
	"./linen/hotel/gown/GS-G002/GS-G002 (thumbnail).jpg": [
		24134,
		24134
	],
	"./linen/hotel/gown/GS-G002/GS-G002.jpg": [
		90775,
		90775
	],
	"./linen/hotel/gown/GS-G003/GS-G003 (thumbnail).jpg": [
		99230,
		99230
	],
	"./linen/hotel/gown/GS-G003/GS-G003-1.jpg": [
		79217,
		79217
	],
	"./linen/hotel/gown/GS-G003/GS-G003.jpg": [
		51103,
		51103
	],
	"./linen/hotel/gown/GS-G003/GS-G003说明.xlsx": [
		71784,
		71784
	],
	"./linen/hotel/gown/GS-G004/GS-G004 (thumbnail).jpg": [
		88562,
		88562
	],
	"./linen/hotel/gown/GS-G004/GS-G004-1.jpg": [
		42437,
		42437
	],
	"./linen/hotel/gown/GS-G004/GS-G004-2.jpg": [
		85210,
		85210
	],
	"./linen/hotel/gown/GS-G004/GS-G004-3.jpg": [
		53495,
		53495
	],
	"./linen/hotel/gown/GS-G004/GS-G004.jpg": [
		57835,
		57835
	],
	"./linen/hotel/gown/GS-G004/GS-G004说明.xlsx": [
		50796,
		50796
	],
	"./linen/hotel/gown/GS-G005/GS-G005 (thumbnail).jpg": [
		65074,
		65074
	],
	"./linen/hotel/gown/GS-G005/GS-G005-1.jpg": [
		63845,
		63845
	],
	"./linen/hotel/gown/GS-G005/GS-G005-2.jpg": [
		41242,
		41242
	],
	"./linen/hotel/gown/GS-G005/GS-G005.jpg": [
		54699,
		54699
	],
	"./linen/hotel/gown/GS-G005/GS-G005说明.xlsx": [
		48932,
		48932
	],
	"./linen/hotel/gown/GS-G006/GS-G006 (thumbnail).jpg": [
		19910,
		19910
	],
	"./linen/hotel/gown/GS-G006/GS-G006-1.jpg": [
		27353,
		27353
	],
	"./linen/hotel/gown/GS-G006/GS-G006-2.jpg": [
		12334,
		12334
	],
	"./linen/hotel/gown/GS-G006/GS-G006-3.jpg": [
		8171,
		8171
	],
	"./linen/hotel/gown/GS-G006/GS-G006.jpg": [
		66967,
		66967
	],
	"./linen/hotel/gown/GS-G006/GS-G006说明.xlsx": [
		75760,
		75760
	],
	"./linen/hotel/gown/GS-G007/GS-G007 (thumbnail).jpg": [
		41454,
		41454
	],
	"./linen/hotel/gown/GS-G007/GS-G007.jpg": [
		92911,
		92911
	],
	"./linen/hotel/gown/GS-G007/GS-G007说明.xlsx": [
		91472,
		91472
	],
	"./linen/hotel/gown/GS-G008/GS-G008 (thumbnail).jpg": [
		95882,
		95882
	],
	"./linen/hotel/gown/GS-G008/GS-G008-1.jpg": [
		15901,
		15901
	],
	"./linen/hotel/gown/GS-G008/GS-G008-2.jpg": [
		6002,
		6002
	],
	"./linen/hotel/gown/GS-G008/GS-G008.jpg": [
		24243,
		24243
	],
	"./linen/hotel/gown/GS-G008/GS-G008说明.xlsx": [
		70524,
		70524
	],
	"./linen/hotel/gown/GS-G009/GS-G009 (thumbnail).jpg": [
		5450,
		5450
	],
	"./linen/hotel/gown/GS-G009/GS-G009.jpg": [
		3219,
		3219
	],
	"./linen/hotel/gown/GS-G009/GS-G009说明.xlsx": [
		55700,
		55700
	],
	"./linen/hotel/gown/GS-G010/GS-G010 (thumbnail).jpg": [
		3806,
		3806
	],
	"./linen/hotel/gown/GS-G010/GS-G010-1.jpg": [
		26193,
		26193
	],
	"./linen/hotel/gown/GS-G010/GS-G010-2.jpg": [
		68422,
		68422
	],
	"./linen/hotel/gown/GS-G010/GS-G010.jpg": [
		6751,
		6751
	],
	"./linen/hotel/gown/GS-G010/GS-G010说明.xlsx": [
		99912,
		99912
	],
	"./linen/hotel/gown/GS-G011/GS-G011 (thumbnail).jpg": [
		72258,
		72258
	],
	"./linen/hotel/gown/GS-G011/GS-G011.jpg": [
		7899,
		7899
	],
	"./linen/hotel/gown/GS-G011/GS-G011说明.xlsx": [
		80620,
		80620
	],
	"./linen/hotel/gown/GS-G012/GS-G012 (thumbnail).jpg": [
		15886,
		15886
	],
	"./linen/hotel/gown/GS-G012/GS-G012-1.jpg": [
		24289,
		24289
	],
	"./linen/hotel/gown/GS-G012/GS-G012.jpg": [
		17135,
		17135
	],
	"./linen/hotel/gown/GS-G012/GS-G012说明.xlsx": [
		9792,
		9792
	],
	"./linen/hotel/gown/GS-G013/GS-G013 (thumbnail).jpg": [
		15498,
		15498
	],
	"./linen/hotel/gown/GS-G013/GS-G013-1.jpg": [
		41373,
		41373
	],
	"./linen/hotel/gown/GS-G013/GS-G013.jpg": [
		82323,
		82323
	],
	"./linen/hotel/gown/GS-G013/GS-G013说明.xlsx": [
		51900,
		51900
	],
	"./linen/hotel/gown/thumbnail/GS-G001 (thumbnail).jpg": [
		44273,
		44273
	],
	"./linen/hotel/others/GS-SL001/GS-SL001 (thumbnail).jpg": [
		14910,
		14910
	],
	"./linen/hotel/others/GS-SL001/GS-SL001.jpg": [
		95743,
		95743
	],
	"./linen/hotel/others/GS-SL002/GS-SL002 (thumbnail).jpg": [
		79864,
		79864
	],
	"./linen/hotel/others/GS-SL002/GS-SL002.jpg": [
		63473,
		63473
	],
	"./linen/hotel/others/GS-SL003/GS-SL003 (thumbnail).jpg": [
		93754,
		93754
	],
	"./linen/hotel/others/GS-SL003/GS-SL003.jpg": [
		10467,
		10467
	],
	"./linen/hotel/others/GS-SL004/GS-SL004 (thumbnail).jpg": [
		58000,
		58000
	],
	"./linen/hotel/others/GS-SL004/GS-SL004.jpg": [
		55481,
		55481
	],
	"./linen/hotel/others/GS-SL005/GS-SL005 (thumbnail).jpg": [
		6806,
		6806
	],
	"./linen/hotel/others/GS-SL005/GS-SL005.jpg": [
		41863,
		41863
	],
	"./linen/hotel/others/GS-SL006/GS-SL006 (thumbnail).jpg": [
		97912,
		97912
	],
	"./linen/hotel/others/GS-SL006/GS-SL006.jpg": [
		69009,
		69009
	],
	"./linen/hotel/others/thumbnail/GS-SL001 (thumbnail).jpg": [
		72221,
		72221
	],
	"./linen/hotel/pajama/GS-P001/GS-P001 (thumbnail).jpg": [
		42251,
		42251
	],
	"./linen/hotel/pajama/GS-P001/GS-P001-1.jpg": [
		87748,
		87748
	],
	"./linen/hotel/pajama/GS-P001/GS-P001-2.jpg": [
		65555,
		65555
	],
	"./linen/hotel/pajama/GS-P001/GS-P001-3.jpg": [
		79094,
		79094
	],
	"./linen/hotel/pajama/GS-P001/GS-P001-4.jpg": [
		50205,
		50205
	],
	"./linen/hotel/pajama/GS-P001/GS-P001.jpg": [
		17846,
		17846
	],
	"./linen/hotel/pajama/GS-P001/GS-P001说明.xlsx": [
		41111,
		41111
	],
	"./linen/hotel/pajama/GS-P002/GS-P002 (thumbnail).jpg": [
		6275,
		6275
	],
	"./linen/hotel/pajama/GS-P002/GS-P002-2.jpg": [
		18251,
		18251
	],
	"./linen/hotel/pajama/GS-P002/GS-P002-3.jpg": [
		22414,
		22414
	],
	"./linen/hotel/pajama/GS-P002/GS-P002.jpg": [
		53694,
		53694
	],
	"./linen/hotel/pajama/GS-P002/GS-P002说明.xlsx": [
		39679,
		39679
	],
	"./linen/hotel/pajama/GS-P003/GS-P003 (thumbnail).jpg": [
		96907,
		96907
	],
	"./linen/hotel/pajama/GS-P003/GS-P003-1.jpg": [
		84196,
		84196
	],
	"./linen/hotel/pajama/GS-P003/GS-P003-2.jpg": [
		84243,
		84243
	],
	"./linen/hotel/pajama/GS-P003/GS-P003-3.jpg": [
		28982,
		28982
	],
	"./linen/hotel/pajama/GS-P003/GS-P003.jpg": [
		84854,
		84854
	],
	"./linen/hotel/pajama/GS-P003/GS-P003说明.xlsx": [
		79679,
		79679
	],
	"./linen/hotel/pajama/thumbnail/GS-P001 (thumbnail).jpg": [
		15233,
		15233
	],
	"./linen/hotel/samue/GS-S001/GS-S001 (thumbnail).jpg": [
		19150,
		19150
	],
	"./linen/hotel/samue/GS-S001/GS-S001-1.jpg": [
		79297,
		79297
	],
	"./linen/hotel/samue/GS-S001/GS-S001-2.jpg": [
		29686,
		29686
	],
	"./linen/hotel/samue/GS-S001/GS-S001-3.jpg": [
		84947,
		84947
	],
	"./linen/hotel/samue/GS-S001/GS-S001.jpg": [
		78351,
		78351
	],
	"./linen/hotel/samue/GS-S001/GS-S001说明.xlsx": [
		51962,
		51962
	],
	"./linen/hotel/samue/GS-S002/GS-S002 (thumbnail).jpg": [
		32266,
		32266
	],
	"./linen/hotel/samue/GS-S002/GS-S002-1.jpg": [
		22845,
		22845
	],
	"./linen/hotel/samue/GS-S002/GS-S002-2.jpg": [
		12946,
		12946
	],
	"./linen/hotel/samue/GS-S002/GS-S002-3.jpg": [
		85327,
		85327
	],
	"./linen/hotel/samue/GS-S002/GS-S002-4.jpg": [
		60388,
		60388
	],
	"./linen/hotel/samue/GS-S002/GS-S002-5.jpg": [
		38433,
		38433
	],
	"./linen/hotel/samue/GS-S002/GS-S002.jpg": [
		16051,
		16051
	],
	"./linen/hotel/samue/GS-S002/GS-S002说明.xlsx": [
		2998,
		2998
	],
	"./linen/hotel/samue/GS-S003/GS-S003 (thumbnail).jpg": [
		98314,
		98314
	],
	"./linen/hotel/samue/GS-S003/GS-S003-1.jpg": [
		75837,
		75837
	],
	"./linen/hotel/samue/GS-S003/GS-S003-2.jpg": [
		65938,
		65938
	],
	"./linen/hotel/samue/GS-S003/GS-S003-3.jpg": [
		33871,
		33871
	],
	"./linen/hotel/samue/GS-S003/GS-S003.jpg": [
		83379,
		83379
	],
	"./linen/hotel/samue/GS-S003/GS-S003说明.xlsx": [
		83062,
		83062
	],
	"./linen/hotel/samue/GS-S004/GS-S004 (thumbnail).jpg": [
		17798,
		17798
	],
	"./linen/hotel/samue/GS-S004/GS-S004-1.jpg": [
		63801,
		63801
	],
	"./linen/hotel/samue/GS-S004/GS-S004-2.jpg": [
		56686,
		56686
	],
	"./linen/hotel/samue/GS-S004/GS-S004.jpg": [
		17751,
		17751
	],
	"./linen/hotel/samue/GS-S004/GS-S004说明.xlsx": [
		42578,
		42578
	],
	"./linen/hotel/samue/GS-S005/GS-S005 (thumbnail).jpg": [
		62694,
		62694
	],
	"./linen/hotel/samue/GS-S005/GS-S005-1.jpg": [
		20089,
		20089
	],
	"./linen/hotel/samue/GS-S005/GS-S005-2.jpg": [
		63950,
		63950
	],
	"./linen/hotel/samue/GS-S005/GS-S005-3.jpg": [
		90411,
		90411
	],
	"./linen/hotel/samue/GS-S005/GS-S005-4.jpg": [
		67576,
		67576
	],
	"./linen/hotel/samue/GS-S005/GS-S005.jpg": [
		92183,
		92183
	],
	"./linen/hotel/samue/GS-S005/GS-S005说明.xlsx": [
		30482,
		30482
	],
	"./linen/hotel/samue/GS-S006/GS-S006 (thumbnail).jpg": [
		9066,
		9066
	],
	"./linen/hotel/samue/GS-S006/GS-S006-1.jpg": [
		76797,
		76797
	],
	"./linen/hotel/samue/GS-S006/GS-S006-2.jpg": [
		38994,
		38994
	],
	"./linen/hotel/samue/GS-S006/GS-S006.jpg": [
		92307,
		92307
	],
	"./linen/hotel/samue/GS-S006/GS-S006说明.xlsx": [
		8982,
		8982
	],
	"./linen/hotel/samue/GS-S007/GS-S007 (thumbnail).jpg": [
		84042,
		84042
	],
	"./linen/hotel/samue/GS-S007/GS-S007-1.jpg": [
		9309,
		9309
	],
	"./linen/hotel/samue/GS-S007/GS-S007-2.jpg": [
		99410,
		99410
	],
	"./linen/hotel/samue/GS-S007/GS-S007-3.jpg": [
		83695,
		83695
	],
	"./linen/hotel/samue/GS-S007/GS-S007.jpg": [
		46899,
		46899
	],
	"./linen/hotel/samue/GS-S007/GS-S007说明.xlsx": [
		71862,
		71862
	],
	"./linen/hotel/samue/GS-S008/GS-S008 (thumbnail).jpg": [
		78878,
		78878
	],
	"./linen/hotel/samue/GS-S008/GS-S008-1.jpg": [
		53777,
		53777
	],
	"./linen/hotel/samue/GS-S008/GS-S008-2.jpg": [
		12358,
		12358
	],
	"./linen/hotel/samue/GS-S008/GS-S008-3.jpg": [
		77059,
		77059
	],
	"./linen/hotel/samue/GS-S008/GS-S008.jpg": [
		61343,
		61343
	],
	"./linen/hotel/samue/GS-S008/GS-S008说明.xlsx": [
		62330,
		62330
	],
	"./linen/hotel/samue/GS-S009/GS-S009 (thumbnail).jpg": [
		27198,
		27198
	],
	"./linen/hotel/samue/GS-S009/GS-S009-1.jpg": [
		96625,
		96625
	],
	"./linen/hotel/samue/GS-S009/GS-S009-2.jpg": [
		68870,
		68870
	],
	"./linen/hotel/samue/GS-S009/GS-S009-3.jpg": [
		12003,
		12003
	],
	"./linen/hotel/samue/GS-S009/GS-S009-4.jpg": [
		35728,
		35728
	],
	"./linen/hotel/samue/GS-S009/GS-S009-5.jpg": [
		87949,
		87949
	],
	"./linen/hotel/samue/GS-S009/GS-S009.jpg": [
		45471,
		45471
	],
	"./linen/hotel/samue/GS-S009/GS-S009说明.xlsx": [
		30554,
		30554
	],
	"./linen/hotel/samue/GS-S010/GS-S010 (thumbnail).jpg": [
		27978,
		27978
	],
	"./linen/hotel/samue/GS-S010/GS-S010-1.jpg": [
		24733,
		24733
	],
	"./linen/hotel/samue/GS-S010/GS-S010-2.jpg": [
		14834,
		14834
	],
	"./linen/hotel/samue/GS-S010/GS-S010-3.jpg": [
		87215,
		87215
	],
	"./linen/hotel/samue/GS-S010/GS-S010-4.jpg": [
		62276,
		62276
	],
	"./linen/hotel/samue/GS-S010/GS-S010-5.jpg": [
		40321,
		40321
	],
	"./linen/hotel/samue/GS-S010/GS-S010.jpg": [
		47155,
		47155
	],
	"./linen/hotel/samue/GS-S010/GS-S010说明.xlsx": [
		19430,
		19430
	],
	"./linen/hotel/samue/thumbnail/GS-S001 (thumbnail).jpg": [
		52633,
		52633
	],
	"./linen/restaurant/cover/cover.png": [
		81722,
		81722
	],
	"./linen/restaurant/glass-towel/GS-TW001/GS-TW001 (thumbnail).jpg": [
		35176,
		35176
	],
	"./linen/restaurant/glass-towel/GS-TW001/GS-TW001.jpg": [
		48065,
		48065
	],
	"./linen/restaurant/glass-towel/GS-TW002/GS-TW002 (thumbnail).jpg": [
		95534,
		95534
	],
	"./linen/restaurant/glass-towel/GS-TW002/GS-TW002.jpg": [
		25615,
		25615
	],
	"./linen/restaurant/glass-towel/GS-TW003/GS-TW003 (thumbnail).jpg": [
		70472,
		70472
	],
	"./linen/restaurant/glass-towel/GS-TW003/GS-TW003.jpg": [
		32545,
		32545
	],
	"./linen/restaurant/glass-towel/thumbnail/GS-TW001 (thumbnail).jpg": [
		89573,
		89573
	],
	"./linen/restaurant/napkin/GS-N001/GS-N001 (thumbnail).jpg": [
		97575,
		97575
	],
	"./linen/restaurant/napkin/GS-N001/GS-N001.jpg": [
		65306,
		65306
	],
	"./linen/restaurant/napkin/GS-N002/GS-N002 (thumbnail).jpg": [
		21539,
		21539
	],
	"./linen/restaurant/napkin/GS-N002/GS-N002.jpg": [
		69182,
		69182
	],
	"./linen/restaurant/napkin/GS-N003/GS-N003 (thumbnail).jpg": [
		79703,
		79703
	],
	"./linen/restaurant/napkin/GS-N003/GS-N003.jpg": [
		32650,
		32650
	],
	"./linen/restaurant/napkin/GS-N004/GS-N004 (thumbnail).jpg": [
		8243,
		8243
	],
	"./linen/restaurant/napkin/GS-N004/GS-N004.jpg": [
		21550,
		21550
	],
	"./linen/restaurant/napkin/GS-N005/GS-N005 (thumbnail).jpg": [
		63175,
		63175
	],
	"./linen/restaurant/napkin/GS-N005/GS-N005.jpg": [
		82266,
		82266
	],
	"./linen/restaurant/napkin/thumbnail/GS-N001 (thumbnail).jpg": [
		94627,
		94627
	],
	"./linen/restaurant/table-cloth/GS-TC001/GS-TC001 (thumbnail).jpg": [
		6193,
		6193
	],
	"./linen/restaurant/table-cloth/GS-TC001/GS-TC001.jpg": [
		68588,
		68588
	],
	"./linen/restaurant/table-cloth/thumbnail/GS-TC001 (thumbnail).jpg": [
		91514,
		91514
	],
	"./linen/spa-and-resort/cover/cover.png": [
		3131,
		3131
	],
	"./linen/spa-and-resort/haori/GS-H001/GS-H001 (thumbnail).jpg": [
		28916,
		28916
	],
	"./linen/spa-and-resort/haori/GS-H001/GS-H001.jpg": [
		63509,
		63509
	],
	"./linen/spa-and-resort/haori/GS-H001/GS-H001说明.xlsx": [
		50054,
		50054
	],
	"./linen/spa-and-resort/haori/thumbnail/GS-H001 (thumbnail).jpg": [
		64470,
		64470
	],
	"./linen/spa-and-resort/others/GS-SL001/GS-SL001 (thumbnail).jpg": [
		12084,
		12084
	],
	"./linen/spa-and-resort/others/GS-SL001/GS-SL001.jpg": [
		27189,
		27189
	],
	"./linen/spa-and-resort/others/GS-SL002/GS-SL002 (thumbnail).jpg": [
		75854,
		75854
	],
	"./linen/spa-and-resort/others/GS-SL002/GS-SL002.jpg": [
		63823,
		63823
	],
	"./linen/spa-and-resort/others/GS-SL003/GS-SL003 (thumbnail).jpg": [
		58728,
		58728
	],
	"./linen/spa-and-resort/others/GS-SL003/GS-SL003.jpg": [
		93313,
		93313
	],
	"./linen/spa-and-resort/others/GS-SL004/GS-SL004 (thumbnail).jpg": [
		68630,
		68630
	],
	"./linen/spa-and-resort/others/GS-SL004/GS-SL004.jpg": [
		85991,
		85991
	],
	"./linen/spa-and-resort/others/GS-SL005/GS-SL005 (thumbnail).jpg": [
		83348,
		83348
	],
	"./linen/spa-and-resort/others/GS-SL005/GS-SL005.jpg": [
		82965,
		82965
	],
	"./linen/spa-and-resort/others/GS-SL006/GS-SL006 (thumbnail).jpg": [
		39934,
		39934
	],
	"./linen/spa-and-resort/others/GS-SL006/GS-SL006.jpg": [
		49247,
		49247
	],
	"./linen/spa-and-resort/others/thumbnail/GS-SL001 (thumbnail).jpg": [
		21491,
		21491
	],
	"./linen/spa-and-resort/relax-wear/GS-RW001/GS-RW001 (thumbnail).jpg": [
		68031,
		68031
	],
	"./linen/spa-and-resort/relax-wear/GS-RW001/GS-RW001-1.jpg": [
		95512,
		95512
	],
	"./linen/spa-and-resort/relax-wear/GS-RW001/GS-RW001-2.jpg": [
		75495,
		75495
	],
	"./linen/spa-and-resort/relax-wear/GS-RW001/GS-RW001-3.jpg": [
		7754,
		7754
	],
	"./linen/spa-and-resort/relax-wear/GS-RW001/GS-RW001.jpg": [
		37922,
		37922
	],
	"./linen/spa-and-resort/relax-wear/GS-RW001/GS-RW001说明.xlsx": [
		97281,
		97281
	],
	"./linen/spa-and-resort/relax-wear/GS-RW002/GS-RW002 (thumbnail).jpg": [
		18785,
		18785
	],
	"./linen/spa-and-resort/relax-wear/GS-RW002/GS-RW002-1.jpg": [
		87458,
		87458
	],
	"./linen/spa-and-resort/relax-wear/GS-RW002/GS-RW002-2.jpg": [
		16717,
		16717
	],
	"./linen/spa-and-resort/relax-wear/GS-RW002/GS-RW002.jpg": [
		55388,
		55388
	],
	"./linen/spa-and-resort/relax-wear/GS-RW002/GS-RW002说明.xlsx": [
		4999,
		4999
	],
	"./linen/spa-and-resort/relax-wear/GS-RW003/GS-RW003 (thumbnail).jpg": [
		32563,
		32563
	],
	"./linen/spa-and-resort/relax-wear/GS-RW003/GS-RW003-1.jpg": [
		44748,
		44748
	],
	"./linen/spa-and-resort/relax-wear/GS-RW003/GS-RW003-2.jpg": [
		21723,
		21723
	],
	"./linen/spa-and-resort/relax-wear/GS-RW003/GS-RW003-3.jpg": [
		20414,
		20414
	],
	"./linen/spa-and-resort/relax-wear/GS-RW003/GS-RW003.jpg": [
		23662,
		23662
	],
	"./linen/spa-and-resort/relax-wear/GS-RW003/GS-RW003说明.xlsx": [
		43985,
		43985
	],
	"./linen/spa-and-resort/relax-wear/GS-RW004/GS-RW004 (thumbnail).jpg": [
		15273,
		15273
	],
	"./linen/spa-and-resort/relax-wear/GS-RW004/GS-RW004-1.jpg": [
		27722,
		27722
	],
	"./linen/spa-and-resort/relax-wear/GS-RW004/GS-RW004-2.jpg": [
		53973,
		53973
	],
	"./linen/spa-and-resort/relax-wear/GS-RW004/GS-RW004-3.jpg": [
		46104,
		46104
	],
	"./linen/spa-and-resort/relax-wear/GS-RW004/GS-RW004.jpg": [
		56852,
		56852
	],
	"./linen/spa-and-resort/relax-wear/GS-RW004/GS-RW004说明.xlsx": [
		34675,
		34675
	],
	"./linen/spa-and-resort/relax-wear/thumbnail/GS-RW001 (thumbnail).jpg": [
		94810,
		94810
	],
	"./linen/spa-and-resort/yukata/GS-Y001/GS-Y001 (thumbnail).jpg": [
		82518,
		82518
	],
	"./linen/spa-and-resort/yukata/GS-Y001/GS-Y001.jpg": [
		3111,
		3111
	],
	"./linen/spa-and-resort/yukata/GS-Y001/GS-Y001说明.xlsx": [
		35962,
		35962
	],
	"./linen/spa-and-resort/yukata/thumbnail/GS-Y001 (thumbnail).jpg": [
		18027,
		18027
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 83224;
module.exports = webpackAsyncContext;